import { AxiosResponse } from 'axios'
import { apiV2 } from '../api'
import {
  RecoverPasswordRequest,
  RecoverPasswordResponse,
} from './dtos/recover-password'

export const recoverPassword = async (
  emailOrCpf: string
): Promise<[RecoverPasswordResponse | null, any]> => {
  try {
    const { data } = await apiV2.post<
      RecoverPasswordRequest,
      AxiosResponse<RecoverPasswordResponse>
    >('/canais/recuperar-senha', { email_cpf: emailOrCpf })

    return [data, null]
  } catch (error) {
    return [null, error]
  }
}
